export const CURRENT_STATE_VERSION = 1;
